import React from 'react';
import Header from '../../components/header/header';
import './events.scss';
import { motion } from "motion/react";

const Events = () => {
  return (
    <div className="events">
      <Header />

      {/* Hero Section */}
      <section className="hero8">
        <div className="hero-content8">
          <h1>What's Coming Up</h1>
          <p>Join us for upcoming events and gatherings throughout the year</p>
        </div>
      </section>

      {/* Upcoming Events Section - Slide from right */}
      <motion.section
        initial={{ opacity: 0, x: 60 }}
        animate={{ opacity: 1, scale: 1, x: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
        className="section8"
      >
        <div className="section-header8">
          <h2 className="section-title8">Upcoming Events</h2>
        </div>

        <div className="events-grid">
          {[
            { title: "Mother's Day", date: "May 10, 2026" },
            { title: "Children's Day", date: "Jun 8, 2026" },
            { title: "Father's Day", date: "Jun 21, 2026" },
            { title: "Thanksgiving Day", date: "Nov 26, 2026" },
            { title: "Christmas", date: "Dec 25, 2026" },
          ].map((event, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="event-card"
            >
              <h3>{event.title}</h3>
              <p className="event-date-text">{event.date}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Recurring Services Section - Blur to focus */}
      <motion.section
        initial={{ opacity: 0, filter: "blur(8px)" }}
        whileInView={{ opacity: 1, filter: "blur(0px)" }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.9 }}
        className="recurring-section"
      >
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 4%' }}>
          <div className="section-header8">
            <h2 className="section-title8">Weekly Services</h2>
            <p className="section-subtitle8">Join us every week for worship, fellowship, and spiritual growth. All are welcome!</p>
          </div>

          <div className="recurring-grid">
            {[
              { icon: "⛪", title: "Sunday Worship", day: "Every Sunday", time: "11:00 AM", desc: "Join us for dynamic worship, biblical teaching, and community." },
              { icon: "📖", title: "Bible Study", day: "Every Tuesday", time: "7:00 PM", desc: "Deep dive into God's Word with study and discussion." },
              { icon: "🙏", title: "Prayer Meeting", day: "Every Friday", time: "7:00 PM", desc: "Gather for a 1-hour corporate prayer and intercession." },
              { icon: "🧑‍🤝‍🧑", title: "Youth Service", day: "Every Last Sunday of the Month", time: "11:00 AM", desc: "Dynamic gatherings for middle and high school students." }
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.12 }}
                className="service-card"
              >
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p className="service-day">{service.day}</p>
                <div className="service-time">{service.time}</div>
                <p className="service-description">{service.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default Events;
